import {useEffect, useState} from "react";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import '../../../static/css/pages/print/print.css';
import {tuitionPaymentInterface} from "../finance/tuition-payments";
import {useParams} from "react-router-dom";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {TomansIcon} from "../../../components/icons/material-icons";

interface printTuitionPaymentInterface {
    day: string,
    list: tuitionPaymentInterface[],
    total:number,
}

export const AdminsPrintFinanceTuitionScreen = () => {
    const {from, to, classId,separatePages} = useParams();
    const [list, setList] = useState([] as printTuitionPaymentInterface[]);
    const [className, setClassName] = useState('');
    const fetchList = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/finance/tuition-payments/print',
            {
                from: from?.toString(),
                to: to?.toString(),
                classId: classId,
            },
            true,
            (d: {
                result: string,
                reason: string,
                list: {
                    day: string,
                    list: tuitionPaymentInterface[],
                }[] | null,
                className: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setClassName(d.className);
                let lst:printTuitionPaymentInterface[] = [];
                if(d.list !== null)
                    d.list.forEach(e=>{
                        let total = 0;
                        if(e.list !== null){
                            e.list.forEach(b=>{
                                total += b.price;
                            });
                        }
                        lst.push({
                            list:e.list === null ? [] : e.list,
                            total:total,
                            day:e.day,
                        });
                    });
                setList(lst);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "پرینت پرداخت شهریه | نهال";
        HideMainLoading();
        fetchList();
        document.body.style.background = '#fff';
    }, []);
    return (
        <>
            <div className="print-screen">
                <button onClick={window.print}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                        <path
                            d="M640-615.385v-120H320v120h-40v-160h400v160h-40Zm-456.923 40h593.846-593.846Zm521.538 100q17 0 28.5-11.5t11.5-28.5q0-17-11.5-28.5t-28.5-11.5q-17 0-28.5 11.5t-11.5 28.5q0 17 11.5 28.5t28.5 11.5ZM640-200v-181.538H320V-200h320Zm40 40H280v-160H143.077v-215.385q0-34 23.077-57t56.923-23h513.846q34 0 57 23t23 57V-320H680v160Zm96.923-200v-175.385q0-17-11.5-28.5t-28.5-11.5H223.077q-17 0-28.5 11.5t-11.5 28.5V-360H280v-61.539h400V-360h96.923Z"/>
                    </svg>
                    پرینت
                </button>
                {
                    list.map((a, i) =>
                        <div key={"KPrInT39cyD" + i}>
                            {
                                a.list === null || a.list.length === 0 ? null :
                                    <div className={'print-small-mode' + (separatePages === '1' ? ' page-separated-print-mode' : ' page-normal-print-mode')}>
                                        <b>گزارش پرداختی‌های شهریه مدرسه نهال</b>
                                        <span>{classId?.toString() === '0' ? 'همه کلاس‌ها' : `کلاس ${className}`} - تاریخ {StringDigitsConvertToPersian(GregorianToPersian(a.day).replaceAll('-', '/'))}</span>
                                        <table className="table open-table table-stripped table-bordered"
                                               style={{display: 'table!important', border: 0,width:'100%'}}>
                                            <thead>
                                            <tr>
                                                <th>ردیف</th>
                                                <th>دانش‌آموز</th>
                                                <th>کدملی</th>
                                                <th>مبلغ</th>
                                                <th>روش پرداخت</th>
                                                <th>کد رهگیری</th>
                                                <th>زمان تسویه حساب</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                (a.list === null ? [] : a.list).map((p, i) =>
                                                    <tr key={"K39Erc1nS" + i}>
                                                        <td style={{width: '10%'}}>{StringDigitsConvertToPersian(i + 1)}</td>
                                                        <td style={{width: '20%'}}>{p.studentName}</td>
                                                        <td style={{width: '15%'}}>{StringDigitsConvertToPersian(p.nationalCode)}</td>
                                                        <td style={{width: '15%'}}>
                                                            <span>{CurrencyFormat(p.price)}<TomansIcon/></span></td>
                                                        <td style={{width: '10%'}}>{p.payMethod === 'old' ? 'سامانه قدیم' : (p.payMethod === 'cash' ? 'فیش' : 'آنلاین')}</td>
                                                        <td style={{width: '10%'}}>{p.traceNo !== '' ? StringDigitsConvertToPersian(p.traceNo) : '-'}</td>
                                                        <td style={{width: '20%'}}></td>
                                                    </tr>
                                                )
                                            }
                                            </tbody>
                                        </table>
                                        <div className={"print-screen-total"}>
                                            <div>
                                                جمع کل:
                                                &nbsp;
                                                {" " + CurrencyFormat(a.total)}
                                            </div>
                                            <TomansIcon/>
                                        </div>
                                    </div>
                            }
                        </div>
                    )
                }
            </div>
        </>
    );
};